import { giphyBlue, giphyYellow } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { PillBlock } from '../../../blocks'
import { SquareButton } from '../../../buttons'

const shadow = css`
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
`

const CellButton = styled(SquareButton)`
    ${shadow}
    cursor: pointer;
    font-size: 17px;
    height: 42px;
    line-height: 44px;
    transition: opacity 0.15s ease-out;
    width: 42px;
`

export const DimGradient = styled.div`
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.33) 0%, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 0.33) 100%);
    border-radius: inherit;
    bottom: 0;
    cursor: pointer;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: opacity 0.15s ease-out;
`

export const CellOverlay = styled.div<{ selected: boolean }>`
    border-radius: inherit;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    ${({ selected }) =>
        selected &&
        css`
            box-shadow: inset 0 0 0 5px ${giphyBlue};

            ${DimGradient} {
                bottom: 5px;
                left: 5px;
                right: 5px;
                top: 5px;
            }
        `}
`

export const DurationPill = styled(PillBlock)`
    ${shadow}
    background: #fff;
    color: #000;
    display: inline-block;
    margin-right: 10px;
`

export const EditButton = styled(CellButton)`
    left: 5px;
    position: absolute;
    top: 5px;
`

export const SelectButton = styled(CellButton)<{ selected: boolean }>`
    position: absolute;
    right: 5px;
    top: 5px;

    ${({ selected }) =>
        selected &&
        css`
            background: ${giphyYellow};
            color: #000;
        `}
`

export const MergeOverlay = styled.div`
    align-items: center;
    background: rgba(97, 87, 255, 0.75);
    border-radius: inherit;
    color: #fff;
    display: flex;
    font-size: 32px;
    height: 100%;
    justify-content: center;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`
